export const dataNormalizedStatic = {
    "CurrentUserSession": {
        "Access_Token": "f437cdd6-278b-496e-b269-c7168fbbb731",
        "BasfUser": false,
        "Basket": null,
        "CanUseOrderSample": true,
        "Country": "France",
        "CountryCode": "FR",
        "Email": "patrick.brill.fr@basfqa.com",
        "FederationLogin": true,
        "Firstname": "Patrick",
        "IsLoggedIn": true,
        "LastUpdated": "/Date(1593100173495+0200)/",
        "Lastname": "Brill-FR",
        "LoginMessage": "successful",
        "Region": "FRA",
        "SessionID": "alommpzmpju5jxk1pcj5tmb1",
        "UserId": "0a675dde-697a-44c5-b4b8-0822f6ac8247",
        "UserRights": [
            "CanUseOrderSample"
        ],
        "WALogin": false
    },
    "Items": [
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "66",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Ethylhexyl Palmitate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527826",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® C 24",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527826",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cegesoft-C-24"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,1004358208955223880597014925",
                "EquivalentAlkaneCarbonNumber": "1,0668972935100647058823529412",
                "InterfacialTension": "1,1566666666666666666666666667",
                "RefractiveIndex": "1,0013840830449826989619377163",
                "Spreadability": "1,125",
                "SurfaceTension": "1,0016042244577387119414458073",
                "Viscosity": "1,168263781555899021123132406"
            },
            "SensoricData": {
                "Gliding": "0,974283971743749832865591468", //vs. 9.74283971743749832865591468
                "RoCushiony": "1,0575275397796826260567589878",
                "RoDistribution": "0,9955478435832600201414790973",
                "RoOil": "0,9798505037374024095005359673",
                "Smoothness": "0,9939483180786313483171713125",
                "Stickiness": "2,54545454545455",
                "Thickness": "0,9922533606744210293334155622",
                "TiPowdery": "1,3282732447817823786496908857",
                "TiResidue1": "1,0714285714285714285714285714",
                "TiResidue2": "0,6365804830259393067459649062",
                "TiSiliconeOilFeel": "0,9075775201572470817120622568",
                "TiWaxdry": "1,1083941335987169820894189077",
                "Wetness": "0,9698707095582579423249364875"
            },
            "Title": "Cegesoft C 24"
        },
        {
            "OtherData": {
                "Chemistry": "Vegetable oil",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Passiflora Incarnata Seed Oil",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30530129",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® PFO",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30530129",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cegesoft-PFO"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "2,626865671641791044776119403",
                "EquivalentAlkaneCarbonNumber": "1,4001155438779411764705882353",
                "InterfacialTension": "0,9066666666666666666666666667",
                "RefractiveIndex": "1,0204152249134948096885813149",
                "Spreadability": "0,3125",
                "SurfaceTension": "1,1084522576117108385414925972",
                "Viscosity": "5,3271509531169500257599175683"
            },
            "SensoricData": {
                "Gliding": "0,9081921935435886664272369981",
                "RoCushiony": "3,5250917992656124744527625174",
                "RoDistribution": "0,9380923017185379299162327063",
                "RoOil": "0,9077719485584247170300616202",
                "Smoothness": "0,9939483180786313483171713125",
                "Stickiness": "8,36363636363636",
                "Thickness": "1,7327409432672616022284008038",
                "TiPowdery": "0,5844402277039835240252188284",
                "TiResidue1": "1,380952380952380952380952381",
                "TiResidue2": "0,4675214039272492574067823695",
                "TiSiliconeOilFeel": "0,8223354326286653696498054475",
                "TiWaxdry": "1,1536067496787654396510748152",
                "Wetness": "0,9261582268739422374706649396"
            },
            "Title": "Cegesoft PFO"
        },
        {
            "OtherData": {
                "Chemistry": "Vegetable oil",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Olus Oil",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30530119",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® PS 6",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30530119",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cegesoft-PS-6"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "2,6417910447761194029850746269",
                "EquivalentAlkaneCarbonNumber": "1,5533674587707",
                "InterfacialTension": "0,92",
                "RefractiveIndex": "1,0165397923875432525951557093",
                "Spreadability": "0,2875",
                "SurfaceTension": "1,0955181979211924735135857759",
                "Viscosity": "8,251004636785162287480680062"
            },
            "SensoricData": {
                "Gliding": "0,9070526801263446769545950237",
                "RoCushiony": "6,5801713586291298902963194899",
                "RoDistribution": "0,9506280563072052396240308739",
                "RoOil": "0,8983703978829059740534900203",
                "Smoothness": "0,9817594312348544804744719104",
                "Stickiness": "9,45454545454545",
                "Thickness": "1,3476874003189845043230084781",
                "TiPowdery": "0,5313092979127120482340699027",
                "TiResidue1": "1,4523809523809523809523809524",
                "TiResidue2": "0,7367636410103531870312808965",
                "TiSiliconeOilFeel": "1,0279192907858365758754863813",
                "TiWaxdry": "1,1193547677999406465719549428",
                "Wetness": "0,9234261967061727552150257768"
            },
            "Title": "Cegesoft PS 6"
        },
        {
            "OtherData": {
                "Chemistry": "Vegetable oil",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Butyrospermum Parkii Butter",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30530126",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® SBE",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30530126",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cegesoft-SBE"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "",
                "EquivalentAlkaneCarbonNumber": "1,1863694520538294117647058824",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cegesoft SBE"
        },
        {
            "OtherData": {
                "Chemistry": "Vegetable oil",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Shorea Stenoptera Seed Butter",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30530130",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® SH",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30530130",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cegesoft-SH"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "2,6119402985074626865671641791",
                "EquivalentAlkaneCarbonNumber": "1,5211038977406411764705882353",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cegesoft SH"
        },
        {
            "OtherData": {
                "Chemistry": "Mixture",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Olus Oil (and) Hydrogenated Vegetable Oil (and) Candelilla Cera",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30530125",
                    "Preservatives": null,
                    "Product_Name": "CEGESOFT® VP",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30530125",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cegesoft-VP"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "",
                "EquivalentAlkaneCarbonNumber": "1,4081814341354529411764705882",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cegesoft VP"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "68",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Ethylhexyl Stearate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527925",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® 868",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527925",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-868"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,1423074626865671641791044776",
                "EquivalentAlkaneCarbonNumber": "1,0860588235294117647058823529",
                "InterfacialTension": "1,08",
                "RefractiveIndex": "1,0020761245674740484429065744",
                "Spreadability": "1",
                "SurfaceTension": "1,0095250827178236021523344808",
                "Viscosity": "1,3734501116263060278207109737"
            },
            "SensoricData": {
                "Gliding": "0,9901177819890725827374820686",
                "RoCushiony": "2,2325581395348845516495402921",
                "RoDistribution": "1,0123192435423922584706854634",
                "RoOil": "0,9831508870663289142502229113",
                "Smoothness": "0,9936017481819054084864911998",
                "Stickiness": "0,363636363636364",
                "Thickness": "0,9636767976278759057948800838",
                "TiPowdery": "0,4967741935483858147762747138",
                "TiResidue1": "0,9056956115779647619047619048",
                "TiResidue2": "0,5934767740539266792139960307",
                "TiSiliconeOilFeel": "0,5878565629986284046692607004",
                "TiWaxdry": "1,0479068320460973294718645627",
                "Wetness": "0,9944133203968586477621632"
            },
            "Title": "Cetiol 868"
        },
        {
            "OtherData": {
                "Chemistry": "Carbonate",
                "Naturalness": "0",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Dipropylheptyl Carbonate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30543500",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® 4 All",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30543500",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-4-All"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,0208955223880597014925373134",
                "EquivalentAlkaneCarbonNumber": "1,0588235294117647058823529412",
                "InterfacialTension": "1,2733333333333333333333333333",
                "RefractiveIndex": "0,9991003460207612456747404844",
                "Spreadability": "1,125",
                "SurfaceTension": "0,9350623308044517228702249256",
                "Viscosity": "1,2467800103039670273055126224"
            },
            "SensoricData": {
                "Gliding": "0,9808063294938770523907285718",
                "RoCushiony": "0,797342192691029878080815885",
                "RoDistribution": "1,0070740661147175754967597973",
                "RoOil": "1,014035208126002147910682316",
                "Smoothness": "0,9883501533183648700843112064",
                "Stickiness": "0",
                "Thickness": "0,9086095520491392740136903734",
                "TiPowdery": "0,9032258064516105723204994797",
                "TiResidue1": "0,9150326797385619047619047619",
                "TiResidue2": "0,5791588784193358228129417691",
                "TiSiliconeOilFeel": "0,5598633933320272373540856031",
                "TiWaxdry": "1,126731682244256766405545437",
                "Wetness": "0,997191011235955756454361823"
            },
            "Title": "Cetiol 4 All"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "66",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Hexyl Laurate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527770",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® A",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527770",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-A"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,8492059701492537313432835821",
                "EquivalentAlkaneCarbonNumber": "0,8534117647058823529411764706",
                "InterfacialTension": "1,05",
                "RefractiveIndex": "0,9961937716262975778546712803",
                "Spreadability": "1,375",
                "SurfaceTension": "0,9657097022158350322515958691",
                "Viscosity": "0,5985574446161772282328696548"
            },
            "SensoricData": {
                "Gliding": "0,9925161864196605083454470267",
                "RoCushiony": "0,7637698898408810283794938943",
                "RoDistribution": "0,9892799662889268646284711287",
                "RoOil": "0,9892520544129211524771075672",
                "Smoothness": "0,9994887211894385667457463382",
                "Stickiness": "2,90909090909091",
                "Thickness": "1,0514923672818482751650143815",
                "TiPowdery": "1,7533206831119541849788822917",
                "TiResidue1": "1,1071428571428571428571428571",
                "TiResidue2": "0,6637134216467178294463371904",
                "TiSiliconeOilFeel": "1,3037025151430058365758754864",
                "TiWaxdry": "1,1275752434508522234117620428",
                "Wetness": "0,964406649222718977813658162"
            },
            "Title": "Cetiol A"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "0",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "C12-15 Alkyl Benzoate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30531263",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® AB",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30531263",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-AB"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,9088776119402985074626865672",
                "EquivalentAlkaneCarbonNumber": "0,8409411764705882352941176471",
                "InterfacialTension": "0,57",
                "RefractiveIndex": "1,0276816608996539792387543253",
                "Spreadability": "0,5",
                "SurfaceTension": "1,0871294408609337923197754086",
                "Viscosity": "1,4092735703245749613601236476"
            },
            "SensoricData": {
                "Gliding": "0,979981538829967824823777349",
                "RoCushiony": "1,6450428396572880539694287097",
                "RoDistribution": "0,9986817822304260985570919664",
                "RoOil": "0,9788058869956783257198364832",
                "Smoothness": "0,9850836731013388115316169258",
                "Stickiness": "2,18181818181818",
                "Thickness": "1,1255411255411274452364677929",
                "TiPowdery": "0,2125237191650849999387892514",
                "TiResidue1": "1,2261904761904761904761904762",
                "TiResidue2": "0,5906632022830881489070126008",
                "TiSiliconeOilFeel": "1,2234746680572859922178988327",
                "TiWaxdry": "1,1193547677999406465719549428",
                "Wetness": "0,9616746190549494955580189993"
            },
            "Title": "Cetiol AB"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "0",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Dibutyl Adipate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527825",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® B",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527825",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-B"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,7712179104477611940298507463",
                "EquivalentAlkaneCarbonNumber": "1,0008823529411764705882352941",
                "InterfacialTension": "0,6",
                "RefractiveIndex": "0,9934256055363321799307958478",
                "Spreadability": "1,25",
                "SurfaceTension": "1,022693091808428862671702149",
                "Viscosity": "0,5473467284904688304997424008"
            },
            "SensoricData": {
                "Gliding": "0,9777025119954818012835173912",
                "RoCushiony": "0,7637698898408810283794938943",
                "RoDistribution": "1,0007710746618754771370057748",
                "RoOil": "0,9829843539625746608426344196",
                "Smoothness": "0,9972725599451117301749789452",
                "Stickiness": "1,45454545454545",
                "Thickness": "0,8737753474595606730085637882",
                "TiPowdery": "2,4440227703984788541347860684",
                "TiResidue1": "0,9523809523809523809523809524",
                "TiResidue2": "0,5948375005324382541650991741",
                "TiSiliconeOilFeel": "1,1683180231858463035019455253",
                "TiWaxdry": "1,1166146092496341694038577589",
                "Wetness": "0,9944589810681862741987226602"
            },
            "Title": "Cetiol B"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Coco-Caprylate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30538241",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® C 5",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30538241",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-C-5"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,8358208955223880597014925373",
                "EquivalentAlkaneCarbonNumber": "0,8823529411764705882352941176",
                "InterfacialTension": "0,941",
                "RefractiveIndex": "0,9940484429065743944636678201",
                "Spreadability": "1,625",
                "SurfaceTension": "0,9563851475552287690919421142",
                "Viscosity": "0,4650180319422977846470891293"
            },
            "SensoricData": {
                "Gliding": "0,9839101469922820805230597073",
                "RoCushiony": "1,594684385382061988719771305",
                "RoDistribution": "1,0070740661147175754967597973",
                "RoOil": "0,9852098418036403968625776635",
                "Smoothness": "0,9915011102364970915242939677",
                "Stickiness": "0",
                "Thickness": "0,8810759292597714468449000294",
                "TiPowdery": "0,8129032258064495150884495317",
                "TiResidue1": "0,8683473389355742857142857143",
                "TiResidue2": "0,5526707714953359260162484452",
                "TiSiliconeOilFeel": "1,2386977577471108949416342412",
                "TiWaxdry": "1,0386333202580791662358042923",
                "Wetness": "1,0166348471096375116817746556"
            },
            "Title": "Cetiol C 5"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Coco-Caprylate/Caprate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30583738",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® C 5C",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30583738",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-C-5C"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,8358208955223880597014925373",
                "EquivalentAlkaneCarbonNumber": "0,8823529411764705882352941176",
                "InterfacialTension": "0,941",
                "RefractiveIndex": "0,9940484429065743944636678201",
                "Spreadability": "1,625",
                "SurfaceTension": "0,9563851475552287690919421142",
                "Viscosity": "0,4650180319422977846470891293"
            },
            "SensoricData": {
                "Gliding": "0,9839101469922820805230597073",
                "RoCushiony": "1,594684385382061988719771305",
                "RoDistribution": "1,0070740661147175754967597973",
                "RoOil": "0,9852098418036403968625776635",
                "Smoothness": "0,9915011102364970915242939677",
                "Stickiness": "0",
                "Thickness": "0,8810759292597714468449000294",
                "TiPowdery": "0,8129032258064495150884495317",
                "TiResidue1": "0,8683473389355742857142857143",
                "TiResidue2": "0,5526707714953359260162484452",
                "TiSiliconeOilFeel": "1,2386977577471108949416342412",
                "TiWaxdry": "1,0386333202580791662358042923",
                "Wetness": "1,0166348471096375116817746556"
            },
            "Title": "Cetiol C 5C"
        },
        {
            "OtherData": {
                "Chemistry": "Carbonate",
                "Naturalness": "94",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Dicaprylyl Carbonate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527869",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® CC",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527869",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-CC"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,8550925373134328358208955224",
                "EquivalentAlkaneCarbonNumber": "0,9957647058823529411764705882",
                "InterfacialTension": "1,0866666666666666666666666667",
                "RefractiveIndex": "0,9937716262975778546712802768",
                "Spreadability": "1,5",
                "SurfaceTension": "0,9792453460780054142575448682",
                "Viscosity": "0,6942126051863297269448737764"
            },
            "SensoricData": {
                "Gliding": "0,9766679061626824065452683355",
                "RoCushiony": "1,2757475083056451258595379742",
                "RoDistribution": "1,0039269596581107683488399368",
                "RoOil": "0,9790329775917049545503752853",
                "Smoothness": "0,9894004722910789015637532791",
                "Stickiness": "0",
                "Thickness": "0,8673091178650880219823093687",
                "TiPowdery": "1,8516129032258016732570239334",
                "TiResidue1": "0,8870214752567695238095238095",
                "TiResidue2": "0,5762952992924153807144832702",
                "TiSiliconeOilFeel": "1,0987319094141050583657587549",
                "TiWaxdry": "1,0571803438341166148028511833",
                "Wetness": "1,0027463929141519682207815408"
            },
            "Title": "Cetiol CC"
        },
        {
            "OtherData": {
                "Chemistry": "Ether",
                "Naturalness": "34",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "PPG-15 Stearyl Ether",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30536786",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® E",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30536786",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-E"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "3,449802985074626865671641791",
                "EquivalentAlkaneCarbonNumber": "0,3866709234575782352941176471",
                "InterfacialTension": "0,1066666666666666666666666667",
                "RefractiveIndex": "1,0030103806228373702422145329",
                "Spreadability": "0,375",
                "SurfaceTension": "1,0650713545670265031248955583",
                "Viscosity": "8,045234415249871200412158681"
            },
            "SensoricData": {
                "Gliding": "0,9321219753057153784602544469",
                "RoCushiony": "5,522643818849449496797700037",
                "RoDistribution": "0,9725656268373707845786676487",
                "RoOil": "0,9119504155253220466279976781",
                "Smoothness": "0,9950563987007848936042115523",
                "Stickiness": "17,0909090909091",
                "Thickness": "1,1403508771929891439124126105",
                "TiPowdery": "0,5313092979127120482340699027",
                "TiResidue1": "1,7738095238095238095238095238",
                "TiResidue2": "0,6365804830259393067459649062",
                "TiSiliconeOilFeel": "0,6769224597857918287937743191",
                "TiWaxdry": "1,1248350849005491125284439096",
                "Wetness": "0,942550407880561125386522388"
            },
            "Title": "Cetiol E"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Oleyl Erucate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527949",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® J 600",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527949",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-J-600"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,7583462686567164179104477612",
                "EquivalentAlkaneCarbonNumber": "1,2508823529411764705882352941",
                "InterfacialTension": "0,9033333333333333333333333333",
                "RefractiveIndex": "1,015570934256055363321799308",
                "Spreadability": "0,4375",
                "SurfaceTension": "1,0964874168644096119782092844",
                "Viscosity": "3,687789799072642967542503864"
            },
            "SensoricData": {
                "Gliding": "0,974598694497083617068770224",
                "RoCushiony": "1,9933554817275802765973885498",
                "RoDistribution": "1,0091721370857854513227656029",
                "RoOil": "1,0006520023334740302673930012",
                "Smoothness": "0,9862495153729526039227765917",
                "Stickiness": "0",
                "Thickness": "1,1426453457587643387829947632",
                "TiPowdery": "0,2258064516129026430801248699",
                "TiResidue1": "1,0084033613445333333333333333",
                "TiResidue2": "0,5762952992924153807144832702",
                "TiSiliconeOilFeel": "0,3009265739159640077821011673",
                "TiWaxdry": "1,0780457453571583236551815544",
                "Wetness": "0,9555256486494951373073375348"
            },
            "Title": "Cetiol J 600"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Coco-Caprylate/Caprate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527919",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® LC",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527919",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "NormalizedProduct",
                "UrlName": "Cetiol-LC"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1",
                "EquivalentAlkaneCarbonNumber": "1",
                "InterfacialTension": "1",
                "RefractiveIndex": "1",
                "Spreadability": "1",
                "SurfaceTension": "1",
                "Viscosity": "1"
            },
            "SensoricData": {
                "Gliding": "1",
                "RoCushiony": "1",
                "RoDistribution": "1",
                "RoOil": "1",
                "Smoothness": "1",
                "Stickiness": "1",
                "Thickness": "1",
                "TiPowdery": "1",
                "TiResidue1": "1",
                "TiResidue2": "1",
                "TiSiliconeOilFeel": "1",
                "TiWaxdry": "1",
                "Wetness": "1"
            },
            "Title": "Cetiol LC"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Myristyl Myristate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527882",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® MM",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527882",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-MM"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,2679223880597014925373134328",
                "EquivalentAlkaneCarbonNumber": "1,1742706166675588235294117647",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cetiol MM"
        },
        {
            "OtherData": {
                "Chemistry": "Ether",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Dicaprylyl Ether",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527880",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® OE",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527880",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-OE"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,7237223880597014925373134328",
                "EquivalentAlkaneCarbonNumber": "0,8235294117647058823529411765",
                "InterfacialTension": "1,1733333333333333333333333333",
                "RefractiveIndex": "0,9916955017301038062283737024",
                "Spreadability": "2",
                "SurfaceTension": "0,9144413622539353631228902777",
                "Viscosity": "0,3397561394470200927357032457"
            },
            "SensoricData": {
                "Gliding": "0,9725294828314848275922721126",
                "RoCushiony": "0,797342192691029878080815885",
                "RoDistribution": "1,0133682790279311897925995184",
                "RoOil": "0,9944751381215425658557431092",
                "Smoothness": "0,9767966446185796347988526035",
                "Stickiness": "0",
                "Thickness": "0,8397754950757201948135190247",
                "TiPowdery": "1,6258064516128990301768990635",
                "TiResidue1": "0,8309990662931838095238095238",
                "TiResidue2": "0,5583979297491734039857939732",
                "TiSiliconeOilFeel": "1,0357472776642509727626459144",
                "TiWaxdry": "1,1568705955553155163990097282",
                "Wetness": "1,0221902287878337234481943735"
            },
            "Title": "Cetiol OE"
        },
        {
            "OtherData": {
                "Chemistry": "Mixture",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Hexyldecanol (and) Hexyldecyl Laurate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527765",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® PGL",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527765",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-PGL"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,9970149253731343283582089552",
                "EquivalentAlkaneCarbonNumber": "1,0588235294117647058823529412",
                "InterfacialTension": "0,8966666666666666666666666667",
                "RefractiveIndex": "1,0048442906574394463667820069",
                "Spreadability": "0,9375",
                "SurfaceTension": "0,9821195815647872731526352729",
                "Viscosity": "2,6483256053580628541988665636"
            },
            "SensoricData": {
                "Gliding": "0,9663073778230399511520736562",
                "RoCushiony": "3,290085679314564945148159745",
                "RoDistribution": "0,9882353200732041727020786854",
                "RoOil": "0,9526904684525702643515206516",
                "Smoothness": "0,992840237456467930031787616",
                "Stickiness": "4,36363636363636",
                "Thickness": "1,1403508771929891439124126105",
                "TiPowdery": "0,9032258064516105723204994797",
                "TiResidue1": "1,2261904761904761904761904762",
                "TiResidue2": "0,6678877198960679347044237636",
                "TiSiliconeOilFeel": "0,7421075855429416342412451362",
                "TiWaxdry": "1,1001736579477986726800537062",
                "Wetness": "0,9589425888871790161113686005"
            },
            "Title": "Cetiol PGL"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Caprylyl Caprylate/Caprate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30538648",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® RLF",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30538648",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-RLF"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,807334328358208955223880597",
                "EquivalentAlkaneCarbonNumber": "0,8117647058823529411764705882",
                "InterfacialTension": "1,0633333333333333333333333333",
                "RefractiveIndex": "0,9937716262975778546712802768",
                "Spreadability": "1,75",
                "SurfaceTension": "0,9495671936098392433407974332",
                "Viscosity": "0,4611025244719216898505924781"
            },
            "SensoricData": {
                "Gliding": "0,9947952132541465318857069845",
                "RoCushiony": "0,9987760097919218600096780621",
                "RoDistribution": "0,994503197367537328215086654",
                "RoOil": "0,9495566182273970185342840778",
                "Smoothness": "1,0017048824337555303181702745",
                "Stickiness": "0,727272727272727",
                "Thickness": "0,9033948507632742959243631978",
                "TiPowdery": "2,6565464895635647572993817714",
                "TiResidue1": "0,9285714285714285714285714286",
                "TiResidue2": "0,7054564041402245590728220391",
                "TiSiliconeOilFeel": "0,9928196076858268482490272374",
                "TiWaxdry": "1,1138744506993288143306869253",
                "Wetness": "1,0053871017392632060302680753"
            },
            "Title": "Cetiol RLF"
        },
        {
            "OtherData": {
                "Chemistry": "Modified shea butter",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Butyrospermum Parkii Butter",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527965",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® SB 45",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527965",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-SB-45"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "2,6477611940298507462686567164",
                "EquivalentAlkaneCarbonNumber": "1,1549447436105529411764705882",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cetiol SB 45"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "47",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Propylheptyl Caprylate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30535766",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® SENSOFT",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30535766",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-Sensoft"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,8492059701492537313432835821",
                "EquivalentAlkaneCarbonNumber": "0,8235294117647058823529411765",
                "InterfacialTension": "1,09",
                "RefractiveIndex": "0,9965397923875432525951557093",
                "Spreadability": "1,75",
                "SurfaceTension": "0,9256375121152367902142308078",
                "Viscosity": "0,4980937660999484801648634724"
            },
            "SensoricData": {
                "Gliding": "0,9714948769986854328540230569",
                "RoCushiony": "1,9136212624584676887893069613",
                "RoDistribution": "1,0039269596581107683488399368",
                "RoOil": "0,9810919323290164371627300375",
                "Smoothness": "0,9809979205094120655205965983",
                "Stickiness": "0",
                "Thickness": "0,8810759292597714468449000294",
                "TiPowdery": "1,3548387096774158584807492196",
                "TiResidue1": "0,8216619981325866666666666667",
                "TiResidue2": "0,5197396115357690084299568803",
                "TiSiliconeOilFeel": "1,1477199563306517509727626459",
                "TiWaxdry": "1,1615073514493262811594293888",
                "Wetness": "1,0444117555006085986037608853"
            },
            "Title": "Cetiol Sensoft"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "65",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Cetearyl Isononanoate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527789",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® SN",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527789",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-SN"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,1841791044776119402985074627",
                "EquivalentAlkaneCarbonNumber": "1,1271176470588235294117647059",
                "InterfacialTension": "1,22",
                "RefractiveIndex": "1,0024221453287197231833910035",
                "Spreadability": "0,875",
                "SurfaceTension": "0,9801811436783529962233882557",
                "Viscosity": "1,8096857290056671818650180319"
            },
            "SensoricData": {
                "Gliding": "0,9617493241540639932615057586",
                "RoCushiony": "2,2913096695226464339756909852",
                "RoDistribution": "0,964208457111593243894657024",
                "RoOil": "0,9620920191280890073280922515",
                "Smoothness": "1,0061372049223993304613616037",
                "Stickiness": "4,72727272727273",
                "Thickness": "1,1255411255411274452364677929",
                "TiPowdery": "1,5939278937381352414764032564",
                "TiResidue1": "1,130952380952380952380952381",
                "TiResidue2": "0,6532776760233454048239303156",
                "TiSiliconeOilFeel": "1,2284889085001361867704280156",
                "TiWaxdry": "1,1056539750484105049213217238",
                "Wetness": "0,9507464983838705693444511123"
            },
            "Title": "Cetiol SN"
        },
        {
            "OtherData": {
                "Chemistry": "Hydrocarbon",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Undecane (and) Tridecane",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30597825",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® ULTIMATE",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30597825",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-Ultimate"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,4917289552238805970149253731",
                "EquivalentAlkaneCarbonNumber": "0,7165882352941176470588235294",
                "InterfacialTension": "1,6333333333333333333333333333",
                "RefractiveIndex": "0,9820069204152249134948096886",
                "Spreadability": "3,125",
                "SurfaceTension": "0,825473747535175963370208215",
                "Viscosity": "0,1030396702730551262235960845"
            },
            "SensoricData": {
                "Gliding": "0,9435532845072760543621784986",
                "RoCushiony": "1,2002098268928116093804007043",
                "RoDistribution": "0,9918893871933244760649092008",
                "RoOil": "0,9220786561081271952324591906",
                "Smoothness": "0,9652484405600654674065979049",
                "Stickiness": "0,363636363636364",
                "Thickness": "0,7646837965592617734851024339",
                "TiPowdery": "3,5045161290322490206035379813",
                "TiResidue1": "0,7251400560224085714285714286",
                "TiResidue2": "0,3796887469107310450793545485",
                "TiSiliconeOilFeel": "1,7397971389826264591439688716",
                "TiWaxdry": "1,2166771035838152354874886097",
                "Wetness": "1,0359188706336720757857237596"
            },
            "Title": "Cetiol Ultimate"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Decyl Oleate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527917",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® V",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527917",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Cetiol-V"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,2619044776119402985074626866",
                "EquivalentAlkaneCarbonNumber": "1,1872941176470588235294117647",
                "InterfacialTension": "1,03",
                "RefractiveIndex": "1,0079584775086505190311418685",
                "Spreadability": "0,875",
                "SurfaceTension": "1,0434143243875538919153771599",
                "Viscosity": "1,4761463163317877382792375064"
            },
            "SensoricData": {
                "Gliding": "0,9845395924989496489294172195",
                "RoCushiony": "1,6450428396572880539694287097",
                "RoDistribution": "0,9955478435832600201414790973",
                "RoOil": "0,9735828032870559178660628196",
                "Smoothness": "0,9972725599451117301749789452",
                "Stickiness": "2,18181818181818",
                "Thickness": "0,9922533606744210293334155622",
                "TiPowdery": "1,1157495256166964754850951827",
                "TiResidue1": "1,0714285714285714285714285714",
                "TiResidue2": "0,699194956766196562662882621",
                "TiSiliconeOilFeel": "0,8123069517429503891050583658",
                "TiWaxdry": "1,0933232615720341629022002719",
                "Wetness": "0,9726027397260284217715868863"
            },
            "Title": "Cetiol V"
        },
        {
            "OtherData": {
                "Chemistry": "Guerbet Alcohol",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Octyldodecanol",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527896",
                    "Preservatives": null,
                    "Product_Name": "EUTANOL® G",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527896",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Eutanol-G"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,8912089552238805970149253731",
                "EquivalentAlkaneCarbonNumber": "1,1783035617963117647058823529",
                "InterfacialTension": "0,73",
                "RefractiveIndex": "1,0062283737024221453287197232",
                "Spreadability": "0,75",
                "SurfaceTension": "0,9797466662210487617392466829",
                "Viscosity": "5,3751674394641937145801133436"
            },
            "SensoricData": {
                "Gliding": "0,9694256653330866433775249455",
                "RoCushiony": "5,5813953488372113791238507301",
                "RoDistribution": "0,9934366048027454234924729177",
                "RoOil": "0,9543255207439651742518420156",
                "Smoothness": "0,9862495153729526039227765917",
                "Stickiness": "1,09090909090909",
                "Thickness": "1,2803134597056083618449915958",
                "TiPowdery": "0",
                "TiResidue1": "1,1204481792717047619047619048",
                "TiResidue2": "0,5877496158000914720626981494",
                "TiSiliconeOilFeel": "0,9517677686644455252918287938",
                "TiWaxdry": "1,1081846586682181957435721958",
                "Wetness": "0,9471925761322028140397304299"
            },
            "Title": "Eutanol G"
        },
        {
            "OtherData": {
                "Chemistry": "Guerbet Alcohol",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Hexyldecanol",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527771",
                    "Preservatives": null,
                    "Product_Name": "EUTANOL® G 16",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527771",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Eutanol-G-16"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,7237223880597014925373134328",
                "EquivalentAlkaneCarbonNumber": "-0,0447601564370658823529411765",
                "InterfacialTension": "0,86",
                "RefractiveIndex": "1,0034602076124567474048442907",
                "Spreadability": "0,875",
                "SurfaceTension": "0,9481634972093178703920323519",
                "Viscosity": "3,7854714064914992272024729521"
            },
            "SensoricData": {
                "Gliding": "0,95833078390233104714106784",
                "RoCushiony": "4,1713586291309708544590247929",
                "RoDistribution": "0,9924139049360929430440839978",
                "RoOil": "0,93597660058498094595977642",
                "Smoothness": "0,9895159955899875481739799833",
                "Stickiness": "3,63636363636364",
                "Thickness": "1,1847801321485546910680666122",
                "TiPowdery": "0,4250474383301699998775785028",
                "TiResidue1": "1,2261904761904761904761904762",
                "TiResidue2": "0,6720620181454180399625103368",
                "TiSiliconeOilFeel": "0,8674635966143852140077821012",
                "TiWaxdry": "1,1193547677999406465719549428",
                "Wetness": "0,9616746190549494955580189993"
            },
            "Title": "Eutanol G 16"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Hexyldecyl Stearate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527811",
                    "Preservatives": null,
                    "Product_Name": "EUTANOL® G 16 S",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527811",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Eutanol-G-16-S"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,5191522388059701492537313433",
                "EquivalentAlkaneCarbonNumber": "1,2037407510385294117647058824",
                "InterfacialTension": "1,0466666666666666666666666667",
                "RefractiveIndex": "1,0067820069204152249134948097",
                "Spreadability": "0,5625",
                "SurfaceTension": "1,0116974700043447745730423448",
                "Viscosity": "2,6702730551262235960844925296"
            },
            "SensoricData": {
                "Gliding": "0,9685864046575289077998696005",
                "RoCushiony": "4,406364749082007220972929891",
                "RoDistribution": "0,9892799662889268646284711287",
                "RoOil": "0,9485120014856729347535845937",
                "Smoothness": "0,992840237456467930031787616",
                "Stickiness": "4",
                "Thickness": "1,2143996354522683139838660219",
                "TiPowdery": "0,4250474383301699998775785028",
                "TiResidue1": "1,2976190476190476190476190476",
                "TiResidue2": "0,7305021936363251906213414784",
                "TiSiliconeOilFeel": "0,8674635966143852140077821012",
                "TiWaxdry": "1,1179846885247868469404431757",
                "Wetness": "0,953478528551640051600090275"
            },
            "Title": "Eutanol G 16 S"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "82",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Isopropyl Myristate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527973",
                    "Preservatives": null,
                    "Product_Name": "ISOPROPYL MYRISTATE",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527973",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "IPM"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,807334328358208955223880597",
                "EquivalentAlkaneCarbonNumber": "0,9529411764705882352941176471",
                "InterfacialTension": "0,9533333333333333333333333333",
                "RefractiveIndex": "0,9927335640138408304498269896",
                "Spreadability": "1,5",
                "SurfaceTension": "0,9398415828347983021957822265",
                "Viscosity": "0,5082946934569809376609994848"
            },
            "SensoricData": {
                "Gliding": "0,9797717236610786353549915116",
                "RoCushiony": "1,594684385382061988719771305",
                "RoDistribution": "1,0039269596581107683488399368",
                "RoOil": "0,9882982739096081180186788526",
                "Smoothness": "0,9872998343456607116032125904",
                "Stickiness": "0",
                "Thickness": "0,8397754950757201948135190247",
                "TiPowdery": "1,5354838709677379729448491155",
                "TiResidue1": "0,8590102707749771428571428571",
                "TiResidue2": "0,5877496158000914720626981494",
                "TiSiliconeOilFeel": "1,3646670212468190661478599222",
                "TiWaxdry": "1,1197765484032417413598422964",
                "Wetness": "1,0249679196269268433763480526"
            },
            "Title": "IPM"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "84",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Isopropyl Palmitate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30528720",
                    "Preservatives": null,
                    "Product_Name": "ISOPROPYL PALMITATE",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30528720",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "IPP"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,8910776119402985074626865672",
                "EquivalentAlkaneCarbonNumber": "0,9823529411764705882352941176",
                "InterfacialTension": "0,98",
                "RefractiveIndex": "0,9955017301038062283737024221",
                "Spreadability": "1,25",
                "SurfaceTension": "0,9610975568998362354199391732",
                "Viscosity": "0,6837712519319938176197836167"
            },
            "SensoricData": {
                "Gliding": "0,9879581327506786842398071562",
                "RoCushiony": "0,3525091799265612474452762517",
                "RoDistribution": "1,0049496595247642474790110871",
                "RoOil": "0,9819397372208505770619349355",
                "Smoothness": "0,9906240762121410934610202231",
                "Stickiness": "1,45454545454545",
                "Thickness": "0,93301435406698889628377163",
                "TiPowdery": "1,1157495256166964754850951827",
                "TiResidue1": "1,0714285714285714285714285714",
                "TiResidue2": "0,6073603952804885699393588937",
                "TiSiliconeOilFeel": "1,213446187171566147859922179",
                "TiWaxdry": "1,1097642128738696596260043245",
                "Wetness": "0,9917269509004157947520722615"
            },
            "Title": "IPP"
        },
        {
            "OtherData": {
                "Chemistry": "Hydrocarbon",
                "Naturalness": "0",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Hydrogenated Polyisobutene",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30674105",
                    "Preservatives": null,
                    "Product_Name": "LUVITOL® LITE EM",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30674105",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Luvitol-Lite"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,7597074626865671641791044776",
                "EquivalentAlkaneCarbonNumber": "0,8823529411764705882352941176",
                "InterfacialTension": "1,5833333333333333333333333333",
                "RefractiveIndex": "0,9975778546712802768166089965",
                "Spreadability": "2,25",
                "SurfaceTension": "0,8758731325824671635306306607",
                "Viscosity": "0,4842864502833590932509015971"
            },
            "SensoricData": {
                "Gliding": "0,9725294828314848275922721126",
                "RoCushiony": "1,1960132890365437008421540601",
                "RoDistribution": "1,0081231016002565068186738523",
                "RoOil": "0,9831508870663289142502229113",
                "Smoothness": "0,9799476015367039578401605996",
                "Stickiness": "0",
                "Thickness": "0,8810759292597714468449000294",
                "TiPowdery": "0,8129032258064495150884495317",
                "TiResidue1": "0,92436974789916",
                "TiResidue2": "0,5677045619116597314647268899",
                "TiSiliconeOilFeel": "0,4128992525823696498054474708",
                "TiWaxdry": "1,1545522176083101340187998979",
                "Wetness": "1,0249679196269268433763480526"
            },
            "Title": "Luvitol Lite"
        },
        {
            "OtherData": {
                "Chemistry": "Triglyceride",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Caprylic/Capric Triglyceride",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527793",
                    "Preservatives": null,
                    "Product_Name": "MYRITOL® 312",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527793",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Myritol-312"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,4925373134328358208955223881",
                "EquivalentAlkaneCarbonNumber": "1,388",
                "InterfacialTension": "0,8433333333333333333333333333",
                "RefractiveIndex": "1,0027681660899653979238754325",
                "Spreadability": "0,6875",
                "SurfaceTension": "0,9867985695665251829818522108",
                "Viscosity": "2,6651210716125708397733127254"
            },
            "SensoricData": {
                "Gliding": "0,9617493241540639932615057586",
                "RoCushiony": "2,6438188494492065651418974695",
                "RoDistribution": "0,9903246125046485578730813416",
                "RoOil": "0,9537350851942943481322201357",
                "Smoothness": "0,9828675118570159241601869155",
                "Stickiness": "4,72727272727273",
                "Thickness": "1,1551606288448410681522672025",
                "TiPowdery": "0,6907020872865255723817102283",
                "TiResidue1": "1,2261904761904761904761904762",
                "TiResidue2": "0,5572688162882833329103866335",
                "TiSiliconeOilFeel": "1,213446187171566147859922179",
                "TiWaxdry": "1,1166146092496341694038577589",
                "Wetness": "0,9507464983838705693444511123"
            },
            "Title": "Myritol 312"
        },
        {
            "OtherData": {
                "Chemistry": "Triglyceride",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Caprylic/Capric Triglyceride",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527906",
                    "Preservatives": null,
                    "Product_Name": "MYRITOL® 318",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527906",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Myritol-318"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,4925373134328358208955223881",
                "EquivalentAlkaneCarbonNumber": "1,3638235294117647058823529412",
                "InterfacialTension": "0,7366666666666666666666666667",
                "RefractiveIndex": "1,0027681660899653979238754325",
                "Spreadability": "0,6875",
                "SurfaceTension": "0,9851609237659169145416262825",
                "Viscosity": "2,5809376609994848016486347244"
            },
            "SensoricData": {
                "Gliding": "0,9797717236610786353549915116",
                "RoCushiony": "1,5149501661129605637023873909",
                "RoDistribution": "1,0133682790279311897925995184",
                "RoOil": "0,9934456607528863273119966723",
                "Smoothness": "0,9872998343456607116032125904",
                "Stickiness": "0",
                "Thickness": "1,0738112887853423272519963469",
                "TiPowdery": "0,9032258064516105723204994797",
                "TiResidue1": "0,9710550887021523809523809524",
                "TiResidue2": "0,5841701418914409194396250257",
                "TiSiliconeOilFeel": "0,7488172885815856031128404669",
                "TiWaxdry": "1,0664538556221347780389114537",
                "Wetness": "0,9749694845231768925347503674"
            },
            "Title": "Myritol 318"
        },
        {
            "OtherData": {
                "Chemistry": "Triglyceride",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Cocoglycerides",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527787",
                    "Preservatives": null,
                    "Product_Name": "MYRITOL® 331",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527787",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Myritol-331"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,7313432835820895522388059701",
                "EquivalentAlkaneCarbonNumber": "1,0042352941176470588235294118",
                "InterfacialTension": "0,2466666666666666666666666667",
                "RefractiveIndex": "1,0069204152249134948096885813",
                "Spreadability": "0,9375",
                "SurfaceTension": "1,0079542796029544467096687945",
                "Viscosity": "4,0956208140133951571354971664"
            },
            "SensoricData": {
                "Gliding": "0,95833078390233104714106784",
                "RoCushiony": "4,1126070991432089721328740998",
                "RoDistribution": "0,9851013814260370956046835859",
                "RoOil": "0,9453781512604996889363480199",
                "Smoothness": "0,9828675118570159241601869155",
                "Stickiness": "5,45454545454545",
                "Thickness": "1,2440191387559819368996654315",
                "TiPowdery": "0,2125237191650849999387892514",
                "TiResidue1": "1,2738095238095238095238095238",
                "TiResidue2": "0,7242407462623028712570211769",
                "TiSiliconeOilFeel": "0,8022784708572344357976653696",
                "TiWaxdry": "1,1344256398266212215693208782",
                "Wetness": "0,9507464983838705693444511123"
            },
            "Title": "Myritol 331"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "86",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Propylene Glycol Dicaprylate/ Dicaprate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30565451",
                    "Preservatives": null,
                    "Product_Name": "MYRITOL® PGDC",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30565451",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "Myritol-PGDC"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,0643194029850746268656716418",
                "EquivalentAlkaneCarbonNumber": "1,0492352941176470588235294118",
                "InterfacialTension": "1,3566666666666666666666666667",
                "RefractiveIndex": "0,9972318339100346020761245675",
                "Spreadability": "1",
                "SurfaceTension": "0,9816182614217439256709334581",
                "Viscosity": "0,9581658938691396187532199897"
            },
            "SensoricData": {
                "Gliding": "0,979981538829967824823777349",
                "RoCushiony": "2,2325581395348845516495402921",
                "RoDistribution": "0,9903246125046485578730813416",
                "RoOil": "0,9516458517108461805708211675",
                "Smoothness": "1,0050291243002359121759779072",
                "Stickiness": "5,45454545454545",
                "Thickness": "1,0811118705855618980808137912",
                "TiPowdery": "0,7969639468690685239640080798",
                "TiResidue1": "1,0714285714285714285714285714",
                "TiResidue2": "0,6866720620181462468886229014",
                "TiSiliconeOilFeel": "1,1933892254001361867704280156",
                "TiWaxdry": "1,1234650056253975570867848431",
                "Wetness": "0,975334769893797904027226049"
            },
            "Title": "Myritol PGDC"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "0",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Isononyl Isononanoate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30682806",
                    "Preservatives": null,
                    "Product_Name": "CETIOL® ININ-GL",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30682806",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "cetiol-inin"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,8507462686567164179104477612",
                "EquivalentAlkaneCarbonNumber": "",
                "InterfacialTension": "1,09",
                "RefractiveIndex": "0,9952941176470588235294117647",
                "Spreadability": "1,625",
                "SurfaceTension": "0,8946893486180274723438387754",
                "Viscosity": "0,5708397733127253992787223081"
            },
            "SensoricData": {
                "Gliding": "1,0104431273700230750166753205",
                "RoCushiony": "0,9767441860465119913466738778",
                "RoDistribution": "0,9891906141713699269659393257",
                "RoOil": "0,9913180743646365024615497696",
                "Smoothness": "0,9939260073395866880140127958",
                "Stickiness": "1,454545455",
                "Thickness": "0,8270676690225588783990045791",
                "TiPowdery": "0,5806451614193533402705511759",
                "TiResidue1": "0,8403361342857142857142857143",
                "TiResidue2": "0,5734974658131803841206909432",
                "TiSiliconeOilFeel": "0,8326848249027237354085603113",
                "TiWaxdry": "1,0959083468268417345998751094",
                "Wetness": "0,997191011235955756454361823"
            },
            "Title": "Cetiol ININ"
        },
        {
            "OtherData": {
                "Chemistry": "Ester",
                "Naturalness": "100",
                "RelatedProduct": {
                    "Chemical_Description": null,
                    "Conclusion": null,
                    "Content": null,
                    "Cosmetic_Properties": null,
                    "DegreeOfBiobased": "",
                    "INCI_Footnote": null,
                    "INCI_Name": "Cetyl Palmitate",
                    "IsActiveProduct": false,
                    "IsEcocert": false,
                    "IsHighlight": false,
                    "IsIECIC2015": false,
                    "IsIECSC2013": false,
                    "IsWhite": false,
                    "NumberOfSustainabilityLeaves": null,
                    "OriginDescription": null,
                    "PRD": "30527819",
                    "Preservatives": null,
                    "Product_Name": "CUTINA® CP",
                    "Properties": null,
                    "RecommendedDoseOfUse": null,
                    "Reference": null,
                    "RelatedActiveSubstanceOrTechnology": null,
                    "RelatedActivesSegments": null,
                    "RelatedAgeOfVolunteers": null,
                    "RelatedApplications": null,
                    "RelatedAsiaFocusRegistration": null,
                    "RelatedCertificates": null,
                    "RelatedClaimProposal": null,
                    "RelatedClaimproposals": null,
                    "RelatedCompliance": null,
                    "RelatedConcepts": null,
                    "RelatedConsumerBenefits": null,
                    "RelatedFormOfDeliveries": null,
                    "RelatedFormulationCostImpact": null,
                    "RelatedFormulations": null,
                    "RelatedFunctions": null,
                    "RelatedGeography": null,
                    "RelatedHyperlinks": null,
                    "RelatedMarketSegments": null,
                    "RelatedNaturalLabel": null,
                    "RelatedNaturalLabels": null,
                    "RelatedOrigin": null,
                    "RelatedProductGroups": null,
                    "RelatedProductLabels": null,
                    "RelatedRegions": null,
                    "RelatedResultsTimeScale": null,
                    "RelatedScientificConcept": null,
                    "RelatedSolutions": null,
                    "RelatedSpecialFormulationFeatures": null,
                    "RelatedStudiesExVivo": null,
                    "RelatedStudiesInVitroInTubo": null,
                    "RelatedStudiesInVivo": null,
                    "RelatedStudiesOnHair": null,
                    "RelatedSustainabilityBenefits": null,
                    "RelatedTargetMoleculesInTheSkin": null,
                    "RelatedTestedSkinArea": null,
                    "SliderListUrlName": null,
                    "Solubilities": null,
                    "UrlName": "30527819",
                    "Use": null,
                    "sRelatedApplications": null,
                    "sRelatedCertificates": null,
                    "sRelatedConcepts": null,
                    "sRelatedFormOfDeliveries": null,
                    "sRelatedFunctions": null,
                    "sRelatedMarketSegments": null,
                    "sRelatedNavigationGroup": null,
                    "sRelatedProductGroups": null,
                    "sRelatedProductGroups_Lvl1": null,
                    "sRelatedProductGroups_Lvl2": null,
                    "sRelatedRegions": null
                },
                "Tags": "",
                "UrlName": "cutina-cp"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,4328358208955223880597014925",
                "EquivalentAlkaneCarbonNumber": "",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "",
                "SurfaceTension": "",
                "Viscosity": ""
            },
            "SensoricData": {
                "Gliding": "",
                "RoCushiony": "",
                "RoDistribution": "",
                "RoOil": "",
                "Smoothness": "",
                "Stickiness": "",
                "Thickness": "",
                "TiPowdery": "",
                "TiResidue1": "",
                "TiResidue2": "",
                "TiSiliconeOilFeel": "",
                "TiWaxdry": "",
                "Wetness": ""
            },
            "Title": "Cutina CP"
        },
        {
            "OtherData": {
                "Chemistry": "Silicone Oil",
                "Naturalness": "0",
                "RelatedProduct": null,
                "Tags": "IsBenchmark",
                "UrlName": "cyclomethicone"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "1,1067752238805970149253731343",
                "EquivalentAlkaneCarbonNumber": "1",
                "InterfacialTension": "1,23",
                "RefractiveIndex": "0,9667820069204152249134948097",
                "Spreadability": "1,625",
                "SurfaceTension": "0,6015841716520169780421777347",
                "Viscosity": "0,421947449768160741885625966"
            },
            "SensoricData": {
                "Gliding": "0,9756333004436895396083173524",
                "RoCushiony": "1,674418604651163413737155219",
                "RoDistribution": "1,0039269598175603016997497677",
                "RoOil": "0,9882982740331448031015512347",
                "Smoothness": "0,9830985586018727690095739194",
                "Stickiness": "0",
                "Thickness": "0,8535423068421078302024265928",
                "TiPowdery": "1,8516129032258016732570239334",
                "TiResidue1": "0,7936507933333333333333333333",
                "TiResidue2": "0,4653316080405515658365804412",
                "TiSiliconeOilFeel": "1,9735184610894941634241245136",
                "TiWaxdry": "1,2287403115600660166666927051",
                "Wetness": "1,0360786825000007275833444522"
            },
            "Title": "Cyclomethicone"
        },
        {
            "OtherData": {
                "Chemistry": "Silicone Oil",
                "Naturalness": "0",
                "RelatedProduct": null,
                "Tags": "IsBenchmark",
                "UrlName": "dimethicone"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "3,5836716417910447761194029851",
                "EquivalentAlkaneCarbonNumber": "1,4705882352941176470588235294",
                "InterfacialTension": "1,2933333333333333333333333333",
                "RefractiveIndex": "0,9709342560553633217993079585",
                "Spreadability": "0,75",
                "SurfaceTension": "0,7018482002606864743825406905",
                "Viscosity": "10,303967027305512622359608449"
            },
            "SensoricData": {
                "Gliding": "0,9472198702636162209104879054",
                "RoCushiony": "6,6046511631627931552190374559",
                "RoDistribution": "0,8995518056124454461432098068",
                "RoOil": "0,8250460408839742539401507891",
                "Smoothness": "0,9740474873705089244359514679",
                "Stickiness": "5,090909091",
                "Thickness": "1,729323308045117982927242241",
                "TiPowdery": "0",
                "TiResidue1": "1,3557422971428571428571428571",
                "TiResidue2": "0,5879797249992774538489413449",
                "TiSiliconeOilFeel": "0,6536964980544747081712062257",
                "TiWaxdry": "1,1234042551581019760448514096",
                "Wetness": "0,9241573029915736826947352469"
            },
            "Title": "Dimethicone (100 Cst)"
        },
        {
            "OtherData": {
                "Chemistry": "Paraffin Oil",
                "Naturalness": "0",
                "RelatedProduct": null,
                "Tags": "IsBenchmark",
                "UrlName": "paraffin-aab2"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,8434328358208955223880597015",
                "EquivalentAlkaneCarbonNumber": "",
                "InterfacialTension": "1,7843333333333333333333333333",
                "RefractiveIndex": "1,0150173010380622837370242215",
                "Spreadability": "0,75",
                "SurfaceTension": "1,0006350055145215734768222987",
                "Viscosity": "2,8325605358062854198866563627"
            },
            "SensoricData": {
                "Gliding": "0,9483488565961028115928112266",
                "RoCushiony": "3,0232558135813964737696050535",
                "RoDistribution": "0,9628262590065926626740853786",
                "RoOil": "0,9376479875138080103956352981",
                "Smoothness": "0,9839867473550478062249821319",
                "Stickiness": "5,090909091",
                "Thickness": "1,2631578944360940245350208604",
                "TiPowdery": "0",
                "TiResidue1": "1,254901960952380952380952381",
                "TiResidue2": "0,5966690802838538709212276934",
                "TiSiliconeOilFeel": "1,0817120622568093385214007782",
                "TiWaxdry": "1,1155482811888712032962516093",
                "Wetness": "0,9297752807022478439433150999"
            },
            "Title": "Light Paraffin Oil"
        },
        {
            "OtherData": {
                "Chemistry": null,
                "Naturalness": "0",
                "RelatedProduct": null,
                "Tags": "IsBenchmark",
                "UrlName": "blandol-white"
            },
            "PhysicalData": {
                "AverageMolecularWeight": "0,8852835820895522388059701493",
                "EquivalentAlkaneCarbonNumber": "",
                "InterfacialTension": "",
                "RefractiveIndex": "",
                "Spreadability": "0,6875",
                "SurfaceTension": "",
                "Viscosity": "3,2972694487377640391550747038"
            },
            "SensoricData": {
                "Gliding": "0,9562517638566164823555198786",
                "RoCushiony": "2,8372093026976754743104382131",
                "RoDistribution": "0,9754811490862130366420048338",
                "RoOil": "0,9365956329281726559309041849",
                "Smoothness": "0,9928216453384823310031562135",
                "Stickiness": "2,545454545",
                "Thickness": "1,2330827072180488213013750919",
                "TiPowdery": "1,0322580646451586264308009157",
                "TiResidue1": "1,1652661066666666666666666667",
                "TiResidue2": "0,6285300506068083367057105236",
                "TiSiliconeOilFeel": "0,933852140077821011673151751",
                "TiWaxdry": "1,0998363343725045841492980103",
                "Wetness": "0,9803370791011242839445780205"
            },
            "Title": "White Paraffin Oil"
        }
    ]
}
